<div>
    <button (click)="open()" class="slant-button" [style.color]="data.categoryColor" [style.fontSize]="data.categoryFontSize"  >{{menuData.categoryName | characterPipe}}</button>

</div>

